<template>
  <div
    class="modal fade"
    id="supplierDetailsModal"
    tabindex="-1"
    aria-labelledby="supplierDetailsModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-rl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-title" id="supplierDetailsModalLabel">
            {{ $t("supplier_page.details_title") }}
          </h5>
          <button
            type="button"
            class="btn-close p-0"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          >
            <img
              src="../../../assets/img/icons/close-circle-2.svg"
              :alt="$t('common.close')"
            />
          </button>
        </div>
        <div class="modal-body p-0" v-if="supplier">
          <ul class="details-list list-style">
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.supplier_code") }}</span>
              <span class="fs-14 fw-bold text-title">{{ supplier.code || $t("supplier_page.not_available_short") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.supplier_name") }}</span>
              <span class="fs-14 fw-bold text-title">{{ supplier.name || $t("supplier_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.phone") }}</span>
              <span class="fs-14 fw-bold text-title">{{ supplier.phone || $t("supplier_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.email") }}</span>
              <span class="fs-14 fw-bold text-title">{{ supplier.email || $t("supplier_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.country") }}</span>
              <span class="fs-14 fw-bold text-title">{{ supplier.country || $t("supplier_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.company_name") }}</span>
              <span class="fs-14 fw-bold text-title">{{ supplier.com_name || $t("supplier_page.not_available") }}</span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.address") }}</span>
              <span class="fs-14 fw-bold text-title">
                {{ supplier.address || $t("supplier_page.not_available") }}
              </span>
            </li>
            <li>
              <span class="fs-14 text-title">{{ $t("supplier_page.status") }}</span>
              <span :class="['fs-14', 'fw-bold', supplier.status ? 'text-success' : 'text-danger']">
                {{ supplier.status ? $t("supplier_page.status_active") : $t("supplier_page.status_inactive") }}
              </span>
            </li>
          </ul>
        </div>
        <div class="modal-body p-4 text-center" v-else>
          <p>{{ $t("supplier_page.no_supplier_selected") }}</p>
        </div>
        <div class="modal-footer pt-20 pb-35 justify-content-end">
          <button
            type="button"
            class="btn style-four px-xxl-6"
            data-bs-dismiss="modal"
          >
            {{ $t("common.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { Supplier } from "../../../services/supplier";

export default defineComponent({
  name: "SupplierDetails",
  props: {
    supplier: {
      type: Object as PropType<Supplier | null>,
      default: null,
    },
  },
  setup() {
    useI18n();
  },
});
</script>
